import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const VisitorsDashboard = () => {
  return <DashboardPageTemplate pageName={"visitors"} />;
};
